import Node from '../node.js';
import Spline from '../spline.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';

export default class NodeSimplifyCurve extends Node
{
	static SIMPLIFY_CHOICES =
	[
		{key: 'byDistance', label: 'By Distance'},
		{key: 'byPercentage', label: 'By Size Percentage'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.SPLINE, 'spline', null);

		this.addInput(PARAM_TYPE.DROPDOWN, 'simplify_type', NodeSimplifyCurve.SIMPLIFY_CHOICES[1].key, { dropdownOptions: NodeSimplifyCurve.SIMPLIFY_CHOICES });

		this.addInput(PARAM_TYPE.FLOAT, 'distance', 0.002, { minValue: 0.0001, maxValue: 0.05, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.INTEGER, 'percentage', 4, { minValue: 0, maxValue: 30, units: PARAM_UNITS.PERCENT });

		this.addOutput(PARAM_TYPE.SPLINE, 'spline');
	}

	getType()
	{ 
		return 'simplifyCurve';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const lastResult = this.getLastInputResult('simplify_type');
		if(strInputName === 'distance')
			return lastResult == NodeSimplifyCurve.SIMPLIFY_CHOICES[0].key;
		else if(strInputName === 'percentage')
			return lastResult == NodeSimplifyCurve.SIMPLIFY_CHOICES[1].key;

		return true;
	}

	getRefreshEnableStatusAfterParamChange(strInputName)
	{
		return strInputName == 'simplify_type';
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		if(!inputValues['spline'])
			return null;

		let pSpline = new Spline(inputValues['spline'])

		let collinearDist = inputValues['distance'];
		if(inputValues['simplify_type'] == 'byPercentage')
			collinearDist = Math.min(...pSpline.getSize().asArray())*(inputValues['percentage']/100);

		pSpline.ensureFullyLinear();
		pSpline.removeCollinearPoints(collinearDist);
		return pSpline.getNumPoints() > 0 ? pSpline.saveToObject() : null;
	}
}